<template>
	<div class="container justify-content-center align-items-center mt-5 text-center" style="max-width: 600px;" :class="{ 'menu-open': $store.state.isMenuOpen }">
		<div style="max-width: 500px;" :style="{ 'margin-right': $store.state.isMenuOpen ? '-12.5%' : '-37.5%' }">
			<div class="card card-login-acesso">
				<div class="card-body">
					<div class="row justify-content-center align-items-center">
						<div class="col-xl-11">
							<div class="text-center">
								<img src="imagens/logo_eproc.png" alt="Logo" title="logo" style="width: 35%">
								<span class="d-block">Justiça Estadual</span>
								<span class="d-block">{{ EPROC_NOME_TRIBUNAL }}</span>
							</div>

							<form @submit.prevent="login">
								<div class="input-group mb-3">
									<span class="input-group-text" id="basic-addon1"><i class="material-icons m-0">person</i></span>
									<input type="text" class="form-control" v-model="email" required placeholder="Usuario" aria-label="Usuario" aria-describedby="basic-addon1" @keyup.enter="login">
								</div>
								<div class="input-group mb-3">
									<span class="input-group-text" id="basic-addon2"><i class="material-icons m-0">lock</i></span>
									<input class="form-control" v-model="password" required placeholder="Senha" aria-label="password" aria-describedby="basic-addon2" @keyup.enter="login" :type="showPassword ? 'text' : 'password'">
									<span class="input-group-text" id="basic-addon2" @click="togglePasswordVisibility" style="cursor: pointer;">
										<i class="material-icons m-0" v-text="showPassword ? 'visibility_off' : 'visibility'"></i>
									</span>
								</div>

								<br />
								<button type="submit" class="btn btn-primary btn-block" style="background-image: linear-gradient(to left, #12b1d1, #006599);">ENTRAR</button>

								<div style="text-align: right;">
									<div>
										<a :href="`${BASE_URL}forgot`" title="Clique aqui se você esqueceu sua senha e quer receber um e-mail para redefini-la">
											<small>Esqueci minha senha</small>
										</a>
									</div>
									<div>
										<a href="#" @click="showToast('Em desenvolvimento.')" data-toggle="popover" data-trigger="hover" data-html="true" title="Autenticação em dois fatores" data-content="Adicione maior segurança no seu acesso ao sistema. Clique para configurar.">
											<small>Autenticação em dois fatores</small>
										</a>
									</div>
								</div>
								<div style="margin-top: -5px">
									<div class="my-3 border-bottom d-flex">
										<div class="w-100 text-left font-weight-light">Outras opções de acesso</div>
										<div class="flex-shrink-1">
											<a href="#" id="dropdownMenuButton" data-toggle="dropdown" data-bs-toggle="dropdown" aria-label="Ajuda"><i class="material-icons">help_outline</i></a>
											<div class="dropdown-menu">
												<a class="dropdown-item" href="#">Como obter certificado digital</a>
												<a class="dropdown-item" href="#">Problemas de acesso com certificado?</a>
												<div class="dropdown-divider"></div>
												<a class="dropdown-item" href="#" title="Fale Conosco">Fale conosco</a>
											</div>
										</div>
									</div>
								</div>
								<div class="row mt-2 d-flex justify-content-center">
									<a class="w-50 btn btn-light" @click="showToast('Em desenvolvimento.')" style="border: solid 1px black; color: #006599;" data-toggle="popover" data-trigger="hover" data-html="true" title="Atenção" data-content="Acople token do certificado digital ao seu computador, antes de acessar esta opção.">
										Certificado Digital
									</a>
								</div>

							</form>
						</div>
					</div>
				</div>
			</div>

			<div class="card mt-2">
				<div class="card-body text-center">
					<div class="row">
						<div class="col">
							<p :class="{ 'truncate': isTruncated }">
								<span style="font-size:14px">O TJRS informa que estão sendo adotadas medidas de restrição de acesso robotizado aos seus Portais, uma vez que estes acessos podem causar instabilidade ou lentidão nos serviços oferecidos. Mais informações <a href="https://www.tjrs.jus.br/novo/noticia/estabelecida-politica-para-bloqueio-de-robos-no-sistema-eproc/">aqui</a>.</span>
							</p>

							<p :class="{ 'truncate': isTruncated }">
								<span style="font-size:14px"><span style="color:#c0392b"><strong>Atenção! Tratando-se de ação/petição envolvendo Coronavírus, também ASSINALE o assunto “COVID – 19” na classificação processual (Portaria 57/2020 do CNJ).</strong></span></span>
							</p>

							<div id="divVerMaisMenos" class="d-flex align-items-end">
								<a href="#" @click="toggleText" style="font-size: small;">{{ isTruncated ? '+ Ver mais' : '- Ver menos' }}</a>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="text-right mr-1" style="text-align: right; font-style: italic; color: #6c757d; font-size: small;">
				Simulador - Versão 1.0.0-0.0.0
			</div>
		</div>
	</div>
</template>

<script>
	import Toastify from 'toastify-js';
	import 'toastify-js/src/toastify.css';

	import axios from 'axios';

	export default {
		data() {
			return {
				BASE_URL: window.Laravel.baseUrl,
				EPROC_NOME_TRIBUNAL: window.Laravel.EPROC_NOME_TRIBUNAL,

				email: '',
				password: '',
				showPassword: false,
				isTruncated: true,

			};
		},
		methods: {
			showToast(message) {
				const toast = Toastify({
					text: `${message}`,
					duration: 3000,
					gravity: 'top',
					position: 'right', // Mudança para o canto superior direito
					stopOnFocus: true,
					style: {
						background: "linear-gradient(to right, black, darkorange)",
					}
				});

				toast.showToast();
			},
			toggleText() {
				this.isTruncated = !this.isTruncated;
			},
			togglePasswordVisibility() {
				this.showPassword = !this.showPassword;
			},
			login() {

				const credentials = {
					email: this.email,
					password: this.password,
				};

				axios.post(this.BASE_URL + 'login', credentials)
					.then(response => {
						const loginComSucesso = response.data.login_com_sucesso;

						if (loginComSucesso) {
							window.location.href = this.BASE_URL + 'home';
						}
						else {
							const mensagem = response.data.resposta;
							alert(mensagem);
						}
					})
					.catch(error => {
						console.error('Erro na autenticação: ', error);
						// Adicione lógica adicional para lidar com falhas na autenticação
					});
			},
		},
		mounted() {

		},
	};
</script>

<style scoped>
	form button {
		width: 100%;
	}

	.card-login-acesso {
		width: 100%;
		height: 670px;
	}

	@media (min-width: 992px) {
		.card-login-acesso {
			width: 100%;
		}
	}

	.truncate {
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 1;
		/* Número de linhas que você quer mostrar inicialmente */
		-webkit-box-orient: vertical;
	}




</style>
